function Wallet({ fill }) {
	return (
		<svg
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0.875001 2.75C0.875001 2.25272 1.07255 1.77581 1.42418 1.42417C1.77581 1.07254 2.25272 0.875 2.75 0.875L13.2188 0.875C13.7575 0.875 14.2741 1.08901 14.6551 1.46994C15.036 1.85087 15.25 2.36753 15.25 2.90625V3.535C16.3425 3.92125 17.125 4.96313 17.125 6.1875L17.125 14.3125C17.125 15.0584 16.8287 15.7738 16.3012 16.3012C15.7738 16.8287 15.0584 17.125 14.3125 17.125L3.6875 17.125C2.94158 17.125 2.22621 16.8287 1.69876 16.3012C1.17132 15.7738 0.875001 15.0584 0.875001 14.3125L0.875001 2.90625H0.881251C0.877025 2.85427 0.87494 2.80215 0.875001 2.75ZM14 2.90625C14 2.475 13.65 2.125 13.2188 2.125L2.75 2.125C2.58424 2.125 2.42527 2.19085 2.30806 2.30806C2.19085 2.42527 2.125 2.58424 2.125 2.75C2.125 2.91576 2.19085 3.07473 2.30806 3.19194C2.42527 3.30915 2.58424 3.375 2.75 3.375L14 3.375V2.90625ZM12.125 10.25C11.9592 10.25 11.8003 10.3158 11.6831 10.4331C11.5658 10.5503 11.5 10.7092 11.5 10.875C11.5 11.0408 11.5658 11.1997 11.6831 11.3169C11.8003 11.4342 11.9592 11.5 12.125 11.5L14 11.5C14.1658 11.5 14.3247 11.4342 14.4419 11.3169C14.5592 11.1997 14.625 11.0408 14.625 10.875C14.625 10.7092 14.5592 10.5503 14.4419 10.4331C14.3247 10.3158 14.1658 10.25 14 10.25L12.125 10.25Z"
				fill={fill}
			/>
		</svg>
	);
}

export default Wallet;
